/**
 * @generated SignedSource<<43b20c1e60352929d988df00920b9580>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeploymentQuery$variables = Record<PropertyKey, never>;
export type DeploymentQuery$data = {
  readonly deployment: {
    readonly targets: ReadonlyArray<{
      readonly address: string;
      readonly contract: {
        readonly admin: string | null | undefined;
        readonly code: {
          readonly checksum: string;
        };
        readonly codeId: number;
        readonly label: string;
      } | null | undefined;
      readonly module: string;
      readonly protocol: string;
      readonly version: {
        readonly contract: string | null | undefined;
        readonly version: string | null | undefined;
      } | null | undefined;
    }>;
  } | null | undefined;
};
export type DeploymentQuery = {
  response: DeploymentQuery$data;
  variables: DeploymentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "module",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "protocol",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ContractInfo",
  "kind": "LinkedField",
  "name": "contract",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "codeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Code",
      "kind": "LinkedField",
      "name": "code",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "checksum",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "admin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ContractVersion",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contract",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeploymentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Deployment",
        "kind": "LinkedField",
        "name": "deployment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DeploymentTarget",
            "kind": "LinkedField",
            "name": "targets",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "DeploymentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Deployment",
        "kind": "LinkedField",
        "name": "deployment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DeploymentTarget",
            "kind": "LinkedField",
            "name": "targets",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "af20a970d2491eda95b8ac4d347cb8ef",
    "id": null,
    "metadata": {},
    "name": "DeploymentQuery",
    "operationKind": "query",
    "text": "query DeploymentQuery {\n  deployment {\n    targets {\n      address\n      module\n      protocol\n      contract {\n        codeId\n        code {\n          checksum\n        }\n        admin\n        label\n      }\n      version {\n        contract\n        version\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "66f4d777eb7b5dc926baf3d06b24394c";

export default node;
